var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":_vm.mode + ' Stack',"inputs-map":_vm.stackInputs,"input-value-change":_vm.valueChange,"save-cb":_vm.saveStack,"reset-inputs":_vm.resetInputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }